var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.483,22.638h-7.11v-2.341c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.341H39.626v-2.341c0-1.104-0.896-2-2-2s-2,0.896-2,2 v2.341h-7.11c-3.86,0-7,3.14-7,7V64.87c0,3.859,3.14,7,7,7h38.967c3.859,0,7-3.141,7-7V29.638 C74.483,25.778,71.343,22.638,67.483,22.638z M28.517,26.638h7.11v2.341c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.341h16.747v2.341 c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.341h7.11c1.654,0,3,1.346,3,3v3.039H25.517v-3.039C25.517,27.983,26.862,26.638,28.517,26.638 z M67.483,67.87H28.517c-1.654,0-3-1.346-3-3V36.677h44.967V64.87C70.483,66.524,69.138,67.87,67.483,67.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.29,41.577L43.278,57.589L36.71,51.02c-0.78-0.781-2.047-0.781-2.828,0c-0.781,0.78-0.781,2.047,0,2.828l7.982,7.983 c0.375,0.375,0.883,0.586,1.414,0.586c0.53,0,1.039-0.211,1.414-0.586l17.426-17.426c0.781-0.781,0.781-2.047,0-2.828 C61.337,40.796,60.071,40.796,59.29,41.577z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.aebcefa7e89fd45f27354996337c0643.svg";
export { ForwardRef as ReactComponent };